let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8tqgK"), load("ewSSf"), load("ffEVr"), load("42PSc")]).then(() => parcelRequire('klAdW'));